import { OVERRIDDEN_BY_COOKIE, OVERRIDDEN_USER_COOKIE } from '../constants/cookies';
import { getCookie, deleteCookie } from '../utils/cookies';
import { setLoginAsHeader } from './axios';

export function setLoginAsUserId({ userId, accId } = {}) {
  if (!userId) {
    deleteCookie(OVERRIDDEN_BY_COOKIE);
    deleteCookie(OVERRIDDEN_USER_COOKIE);
  }

  setLoginAsHeader({ userId, accId });
}

export function getLoginAsUserId() {
  const hasItem = Boolean(getCookie(OVERRIDDEN_USER_COOKIE));

  return (
    hasItem && {
      userId: getCookie(OVERRIDDEN_USER_COOKIE),
      accId: getCookie(OVERRIDDEN_BY_COOKIE),
    }
  );
}
